// redux utils
import {AnyAction} from '@reduxjs/toolkit'
import {LOCATION_CHANGE, RouterState} from 'redux-first-history'

export interface LocationChangePayload extends RouterState {
    isFirstRendering: boolean
}

export interface LocationChangeAction {
    type: typeof LOCATION_CHANGE
    payload: LocationChangePayload
}

/** location change action type safe */
export const isLocationChangeAction = (action: AnyAction): action is LocationChangeAction =>
    action.type === LOCATION_CHANGE
